import AdvertisingAddPage from './AdvertisingAddPage';

export default AdvertisingAddPage;
